import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import TeamLogin from './pages/TeamLogin';
import DIOLogin from './pages/DIOLogin';
import StaffTable from './pages/team/StaffTable';
import Courses from './pages/team/Courses';
import CoursesCalendar from './pages/team/CoursesCalendar';
import ExpiryTracker from './pages/team/ExpiryTracker';
import GrandRounds from './pages/team/GrandRounds';
import GrandRoundsCalendar from './pages/team/GrandRoundsCalendar';
import PostGradTraining from './pages/team/PostGradTraining';
import OnJobTraining from './pages/team/OnJobTraining';
import Dashboard from './pages/dio/Dashboard';
import Reports from './pages/dio/Reports';
import StaffOverview from './pages/dio/StaffOverview';
import TraineeDashboard from './pages/dio/TraineeDashboard';
import TraineeEvaluation from './pages/TraineeEvaluation';

export default function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/team/login" element={<TeamLogin />} />
          <Route path="/dio/login" element={<DIOLogin />} />
          <Route path="/evaluation/:traineeId" element={<TraineeEvaluation />} />

          {/* Team Portal */}
          <Route
            path="/team"
            element={
              <ProtectedRoute role="team">
                <Layout role="team" />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/team/staff" replace />} />
            <Route path="staff" element={<StaffTable />} />
            <Route path="courses" element={<Courses />} />
            <Route path="courses/calendar" element={<CoursesCalendar />} />
            <Route path="expiry-tracker" element={<ExpiryTracker />} />
            <Route path="grand-rounds" element={<GrandRounds />} />
            <Route path="grand-rounds/calendar" element={<GrandRoundsCalendar />} />
            <Route path="trainees" element={<PostGradTraining />} />
            <Route path="ojt" element={<OnJobTraining />} />
          </Route>

          {/* DIO Portal */}
          <Route
            path="/dio"
            element={
              <ProtectedRoute role="dio">
                <Layout role="dio" />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dio/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="reports" element={<Reports />} />
            <Route path="staff" element={<StaffOverview />} />
            <Route path="trainees" element={<TraineeDashboard />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </NotificationProvider>
    </AuthProvider>
  );
}
